import { EntriesState } from '../../../../core/features/store/base-feature-state';

export const ALERTS_FEATURE = 'alerts';

export interface StateWithAlerts {
  [ALERTS_FEATURE]: AlertsState;
}

export interface AlertsState {
  dismissals: EntriesState<DismissalState>;
}

export interface DismissalState {
  dismissed: boolean;
  reappearable: boolean;
  messageHash?: string;
}
